import styled from "styled-components";
import colors from '../../assets/styles/colors';

export const TableContainer = styled.table`
    font-family: 'Montserrat', sans-serif;
    width: 100%;
    height: 100%;
    padding: 15px;
    background-color: ${colors.white};
    box-shadow: 0px 20px 25px ${colors.shadow};
    border-collapse: collapse;
    -moz-border-radius: 20px;
    -webkit-border-radius: 20px;
    border-radius: 20px;
`

export const TableHeader = styled.thead`
    border-collapse: collapse; 
    border-bottom: 2px solid ${colors.darkGray};
`

export const TableHeaderCell = styled.th`
    color: ${colors.darkGray};
    width: ${props => props.size + '%'};
    font-weight: 600;
    padding: 25px;
`

export const TableBody = styled.tbody`
    border-top: 3px solid ${colors.normalGray};
`

export const TableRow = styled.tr`
`

export const TableCell = styled.td`
    padding: 45px;
    font-size: 16px;
    font-weight: 500;
    color: ${props => props.color || 'initial'};

    span{
        color: ${colors.darkblue};
        text-decoration: underline;
        cursor: pointer;
    }
`